import axios from "axios";
import router from '@/router'
import store from '@/store'

import { addToLocalStorageArray, addToLocalStorageObject, updateLocalStorageArray, removeLocalStorageTokens } from '@/store/helper'
import { operatorValues } from '@/utils/utils'

const state = {
  background_color: 'white',
  // server_url : 'http://127.0.0.1:8000',
  server_url: process.env.VUE_APP_URL,
  media_url: '/media/issues/files/',
  status: '',
  workspaces: JSON.parse(localStorage.getItem('workspaces')) || '',
  error_message: '',
  login_error_message: '',
  signup_error_message: '',
  token: localStorage.getItem('token') || '',
  refresh: localStorage.getItem('refresh') || '',
  user: JSON.parse(localStorage.getItem('user')) || '',
  // form error
  profileFormErr: {},
  profileFormStatus: null,
  updatePasswordFormErr: {},
  updatePasswordFormStatus: null,
  requestPasswordFormErr: '',
  requestPasswordFormStatus: null,
  validateResetFormStatus: {status: null, error:null},
  //
  workspace_invites_data: [],
};

const getters = {
  auth_state: state => state,
  server_url: state => state.server_url,
  user: state => state.user || '',
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  workspaces: state => state.workspaces || '',
  // form console.error();
  profileFormErr: state => state.profileFormErr || {},
  workspace_invites_data: state => state.workspace_invites_data,


};

const actions = {
  loginUser ({ commit }, userInfo) {
    commit('auth_request')

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: "account/api/login/",
        data: userInfo,
      }).then(response => {
          const token = response.data.access
          const refresh = response.data.refresh
          const user = response.data.user
          const invites = response.data.user.invites
          const workspaces = (response.data.user.workspaces)

          const payload = {
            "token": token,
            "user": user,
            "refresh": refresh,
            "workspaces": workspaces,
            "invites": invites,
          }
          const loginContinue = localStorage.getItem('loginContinue')

          localStorage.setItem('token', token)
          localStorage.setItem('refresh', refresh)
          localStorage.setItem('user', JSON.stringify(user))
          localStorage.setItem('workspaces', JSON.stringify(workspaces))

          axios.defaults.headers.common['Authorization'] = 'Bearer '+token
          commit('auth_success', payload)

          if (Array.isArray(workspaces) && workspaces.length){
              const ws_slug = workspaces[workspaces.length - 1].slug
              if (loginContinue){ router.push(loginContinue) }
              else { router.push({name: 'workspaceview', params: {slug: ws_slug}}) }
          } else{ router.push({name: 'joinworkspace'}) }
          resolve(response);  // Let the calling function know that http is done. You may send some data back

        }, error => {
          const err_message = error.response.data.detail
          commit('login_auth_error', err_message)
          removeLocalStorageTokens()
          reject(error);
        })
    })

  },

  // Signup action
  signupUser ({ commit }, userInfo) {
    commit('auth_request')

    return new Promise((resolve, reject) => {
      axios.post(
        "account/api/signup/", userInfo
      ).then(response => {

          const token = response.data.access
          const refresh = response.data.refresh
          const user = response.data.user
          const invites = response.data.user.invites
          const workspaces = (response.data.user.workspaces)

          const payload = {
            "token": token,
            "user": user,
            "refresh": refresh,
            "workspaces": workspaces,
            "invites": invites,
          }

          const loginContinue = localStorage.getItem('loginContinue')

          localStorage.setItem('token', token)
          localStorage.setItem('refresh', refresh)

          localStorage.setItem('user', JSON.stringify(user))
          localStorage.setItem('workspaces', JSON.stringify(workspaces))

          axios.defaults.headers.common['Authorization'] = 'Bearer '+token
          commit('auth_success', payload)
          router.push({name: 'joinworkspace'})
          resolve(response);  // Let the calling function know that http is done. You may send some data back

        }, error => {
          // const err_message = error.response.data.email[0] || ''
          // console.log(error.response.data);
          const err_message = operatorValues(error.response.data)
          commit('signup_auth_error', err_message)
          removeLocalStorageTokens()
          reject(error);

        })
    })


  },

  // Logout action
  logout({commit}){
    return new Promise((resolve, reject) => {
      commit('logout')
      localStorage.removeItem('token')
      localStorage.removeItem('refresh')
      localStorage.removeItem('user')
      localStorage.removeItem('workspaces')

      store.dispatch('workspace/logout')

      // localStorage.clear()
      delete axios.defaults.headers.common['Authorization']
      resolve()
      router.push({name: 'login'})
    })
  },

  async refreshToken ({ commit }, token) {
    const payload = {"token": token}
    commit('auth_refresh_success', payload)
  },

  async joinWorkspace ({ commit }, userInfo) {
    const response = await axios({
      method: 'POST',
      url: "account/api/workspace/",
      data: userInfo,
    }).then(response => {
      commit('join_workspace', response.data)
      router.push({name: 'welcome', params: {slug: response.data.slug} })
    }).catch(error => {
      commit('auth_error', error.response.data);
    })
  },

  // Profile related actions---
  async editUser ({ commit }, payload) {

    const response = await axios({
      method: 'PUT',
      url: `account/api/user/profile/${payload.user_id}`,
      data: payload.data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      commit('edit_user_profile_success', response.data)
    }).catch(error => {
      if (error.response) {
        commit('edit_user_profile_error', error.response.data)
      }
    })
  },

  async updatePassword ({ commit }, payload) {

    const response = await axios({
      method: 'PUT',
      url: `account/api/user/password/update/`,
      data: payload.data,
    }).then(response => {
      commit('update_user_passsword_success', response.data)
    }).catch(error => {
      if (error.response) {
        commit('update_user_passsword_error', error.response.data)
      }
    })
  },
  //
  // async sendPasswordRequest ({ commit }, payload) {
  //   const response = await axios({
  //     method: 'POST',
  //     url: `account/api/user/password_reset/`,
  //     data: payload,
  //   }).then(response => {
  //     commit('request_password_success', response.data)
  //   }).catch(error => {
  //     if (error.response) {
  //       commit('request_password_error', error.response.data)
  //     }
  //   })
  // },

  sendPasswordRequest ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `account/api/user/password_reset/`,
        data: payload,
      }).then(response => {
        commit('request_password_success', response.data)
        resolve(response);  // Let the calling function know that http is done. You may send some data back
      }, error => {
        if (error.response) {
          commit('request_password_error', error.response.data)
        }
        reject(error);
      })

    })
  },

  async validateResetToken ({ commit }, payload) {
    const response = await axios({
      method: 'POST',
      url: `account/api/user/password_reset/validate_token/?token=${payload.token}`,
      data: payload,
    }).then(response => {
      commit('validate_reset', {"status": 1, "data": response.data})
    }).catch(error => {
      if (error.response) {
        commit('validate_reset', {"status": 2, "data": error.response.data})
      }
    })
  },

  async resetActualPassword ({ commit }, payload) {
    const response = await axios({
      method: 'POST',
      url: `account/api/user/password_reset/confirm/`,
      data: payload,
    }).then(response => {
      // commit('validate_reset', {"status": 1, "data": response.data})
      router.push({name: 'accountresetsuccess' })
    }).catch(error => {
      if (error.response) {
        // console.log(error.response);
        commit('validate_reset', {"status": 3, "data": error.response.data})
      }
    })
  },

  async fetchWorkspaceInvites ({ commit }, payload) {
    const response = await axios({
      method: 'GET',
      url: `account/api/workspaceinvite/${payload.user_id}`,
      data: payload,
    }).then(response => {
      commit('workspace_invites', response.data)
    }).catch(error => {
      // if (error.response) {
      //   // console.log(error.response);
      //   commit('validate_reset', {"status": 3, "data": error.response.data})
      // }
    })
  },

  async acceptWorkspaceInvites ({ commit }, payload) {
    const response = await axios({
      method: 'PUT',
      url: `account/api/workspaceinvite/${payload.id}/accept/`,
      data: payload.data,
    }).then(response => {
      const payloadx = {'invite_id': payload.id, 'data': response.data }
      commit('acceptwsinvites', payloadx)
      router.push({name: 'welcome', params: {slug: response.data.data[0].slug} })
    }).catch(error => {
      // if (error.response) {
      //   // console.log(error.response);
      //   commit('validate_reset', {"status": 3, "data": error.response.data})
      // }
    })
  },





  // async refreshToken ({ commit }) {
  //   const response = await axios({
  //     method: 'POST',
  //     url: "account/api/token/refresh/",
  //     data: {refresh: state.refresh},
  //   }).then(response => {
  //
  //     const token = response.data.access
  //     const payload = {"token": token}
  //
  //     localStorage.setItem('token', token)
  //     axios.defaults.headers.common['Authorization'] = 'Bearer '+token
  //     commit('auth_refresh_success', payload)
  //     return token
  //
  //   }).catch(error => {
  //       console.log('ERRORR FROM AUTH!');
  //
  //       localStorage.removeItem('token')
  //       localStorage.removeItem('refresh')
  //       localStorage.removeItem('user')
  //       commit('logout')
  //       router.push({name: 'login'})
  //   })
  //
  //
  // },

  // async confirmWorkspace ({ commit }, userInfo) {
  //   const response = await axios({
  //     method: 'POST',
  //     url: "http://127.0.0.1:8000/account/api/workspacecreated/",
  //     data: userInfo,
  //     headers: { 'Authorization': `Bearer ${state.token}`}
  //   }).then(response => {
  //
  //     // const token = response.data.access
  //     // const user = response.data.user
  //     console.log(response)
  //
  //   })
  //
  // },

};

const mutations = {
  auth_request(state){
    state.status = 'loading'
  },

  auth_success(state, payload){
    state.status = 'success'
    state.error_message = ''
    state.token = payload['token']
    state.refresh = payload['refresh']
    state.user = payload['user']
    state.workspaces = payload['workspaces']
    state.workspace_invites_data = payload['invites']
  },

  auth_refresh_success(state, payload){
    state.status = 'success'
    state.error_message = ''
    state.token = payload['token']
  },

  auth_error(state, err_message){
    state.error_message = err_message
    state.status = 'error'
  },

  login_auth_error(state, err_message){
    state.login_error_message = err_message
    state.status = 'error'
  },

  signup_auth_error(state, err_message){
    state.signup_error_message = err_message
    state.status = 'error'
  },

  auth_reset(state, data){
    if (data=='login') {
      state.login_error_message = ''
    }
    if (data=='signup') {
      state.signup_error_message = ''
    }
    if (data=='forgot') {
      state.requestPasswordFormErr = ''      
    }
  },

  join_workspace(state, data){
    state.workspaces.unshift(data)
    addToLocalStorageArray('workspaces', data)
  },

  edit_user_profile_success(state, data){
    // Object.keys(state.profileFormErr).forEach(k => delete state.profileFormErr[k])
    // Empty profileFormErr---
    Object.keys(state.profileFormErr).forEach( function (key) {
      delete state.profileFormErr[key]
    })
    state.profileFormStatus = 1

    //
    updateLocalStorageArray('user', data)
    state.user = data

  },

  edit_user_profile_error(state, data){
    state.profileFormErr = JSON.parse(JSON.stringify(data))
    state.profileFormStatus = 2
  },

  update_user_passsword_success(state, data){
    state.updatePasswordFormStatus = 1
  },

  update_user_passsword_error(state, data){
    state.updatePasswordFormErr = JSON.parse(JSON.stringify(data))
    state.updatePasswordFormStatus = 2
  },

  request_password_success(state, data){
    state.requestPasswordFormStatus = 1
  },

  request_password_error(state, data){
    state.requestPasswordFormErr = data
    state.requestPasswordFormStatus = 2
  },

  validate_reset(state, data){
    // success
    if (data.status == 1) {
      state.validateResetFormStatus.status = 1
    }
    // error- token validation
    if (data.status == 2) {
      state.validateResetFormStatus.status = 2
      state.validateResetFormStatus.error = data.data
    }
    // error- reset password validation
    if (data.status == 3) {
      // state.validateResetFormStatus.status = 2
      state.validateResetFormStatus.error = data.data
    }
    // set
    if (data.status == 4) {
      Object.keys(state.validateResetFormStatus).forEach(key => state.validateResetFormStatus[key]=null);
    }
  },

  setrequestPasswordFormStatus(state, data){
    console.log(22);
    state.requestPasswordFormStatus = data
  },

  workspace_invites(state, data){
    state.workspace_invites_data = data
  },

  acceptwsinvites(state, data){
    const value = state.workspace_invites_data.filter(item => item.id !== data.invite_id);
    state.workspace_invites_data = value
    state.workspaces.unshift(data.data.data[0])
    addToLocalStorageArray('workspaces', data.data.data[0])
    // console.log(state.workspace_invites_data[0].);
    // state.workspace_invites_data = data
  },

  logout(state){
    state.status = ''
    state.workspaces = []
    state.error_message = ''
    state.login_error_message = ''
    state.signup_error_message = ''
    state.refresh = ''
    state.token = ''
    state.user = {}
    state.workspace_invites_data = []
    state.profileFormErr = {}

    state.profileFormStatus = null
    state.updatePasswordFormErr = {}
    state.updatePasswordFormStatus = null
    state.requestPasswordFormErr = ''
    state.requestPasswordFormStatus = null
    state.validateResetFormStatus = {status: null, error:null}
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
